export enum ModelWebSocketEmitEvent {
  SubscribeToUserModels = "user:models:subscribe",
}

export enum ModelWebSocketSubscribeEvent {
  ModelUpdated = "model:updated",
}


export enum ReprocessReason {
  BAD_QUALITY = "BAD_QUALITY",
  BAD_ORIENTATION = "BAD_ORIENTATION",
  OTHER = "OTHER",
  MODEL_FAILED = "MODEL_FAILED",
}

export interface ReprocessModelRequest {
  reason: ReprocessReason;
  comment?: string;
}

export interface IReprocessMonthlyStatus {
  usage: number;
  limit: number;
}
